import { useEffect, useState } from "react";
import { Box, Button, Grid, Typography } from "@mui/material";
import { useForm } from "react-hook-form";
import Condition from "../../../../../components/condition/Condition";
import { useGenerateArrayFromObj } from "../../../../../components/input/hook/useGenerateOptions2";
import ProductWithPriceInvoice, {
  ProductWithPriceInvoiceData,
} from "../../../../../components/product/ProductWithPrice-v2";
import { MainContainerForm } from "../../../../../styles/Main.styles";
import { useGetInvoiceConstant } from "../../../api/invoice/constant/resolver";
import GrosirInput from "../../__component/GrosirInput";
import PaymentMethodInput from "../../__component/PaymentMethodInput";
import PrintInvoice from "../../__component/PrintInvoice";
import RetailInput from "../../__component/RetailInput";
import Input from "../../../../../components/input/Input-v2";
import { M_InvoiceDetail } from "../../../type/Invoice.type";
import {
  NonEditableTableConfig,
  // ReturTableConfig,
  ReturTableListConfig,
} from "../../../tableConfig/TableConfig";
import { LoadingButton } from "../../../../../components/button/Button";
// import { useCreateRetur } from "../../../api/invoice/retur/resolver";
import { FromStringToDate } from "../../../../../utils/Helper";
import TableFC from "../../../../../components/table/Table";
import { ModalFC } from "../../../../../components/modal/Modal";
import { useCancelInvoice } from "../../../api/invoice/resolver";

export interface Form_Create_Invoice {
  invoice_date: string;
  invoice_type: string;
  payment_method_id: string;
  invoice_status: string;
  product_list: any;
  customer_name: string;
  customer_address?: string;
  customer_phone_number?: string;
  sub_dealer_id?: string;
  payment_due_date?: string;
  description: string;
  descriptionRetur: string;
  returQuantity?: number;
}

interface Form {
  dataInvoice: M_InvoiceDetail;
  hideRetur?: boolean;
}

export default function FormInvoiceLunas({ dataInvoice, hideRetur }: Form) {
  const { control, setValue, watch, trigger, getValues } =
    useForm<Form_Create_Invoice>({
      defaultValues: {
        customer_name: "",
      },
    });
  // const { mutate: mutateRetur, isLoading: loadingRetur } = useCreateRetur();
  const { mutate: mutateCancel, isLoading: loadingCancel } = useCancelInvoice();
  const { data: dataRawInvoiceConstant, isLoading: fetchInvoiceConstant } =
    useGetInvoiceConstant();
  const dataInvoiceConstant = dataRawInvoiceConstant?.data.data;
  const { data: dataInvoiceType } = useGenerateArrayFromObj({
    dataSource: dataInvoiceConstant?.type,
  });
  const { data: dataInvoiceStatus } = useGenerateArrayFromObj({
    dataSource: dataInvoiceConstant?.status,
  });
  const [productWithPriceData, setProductWithPriceData] = useState<
    ProductWithPriceInvoiceData[]
  >([]);
  const [isReturMode, setIsReturMode] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const isFetching = fetchInvoiceConstant;
  const { body: bodyListRetur, header: headerListRetur } =
    ReturTableListConfig();
  const {
    body: bodyNonEdit,
    header: headerNonEdit,
    lastRow: lastRowNonEdit,
  } = NonEditableTableConfig(dataInvoice.grand_total);
  // const {
  //   body: bodyRetur,
  //   header: headerRetur,
  //   lastRow: lastRowRetur,
  // } = ReturTableConfig({
  //   grandTotal: productWithPriceData.reduce((acc, item) => {
  //     return acc + item.price * item.quantity;
  //   }, 0),
  //   onRetuQuantityChange: (id, qty) => {
  //     setProductWithPriceData((prev) =>
  //       prev.map((item) => {
  //         if (item.id === id) {
  //           item.returQuantity = qty;
  //         }
  //         return item;
  //       })
  //     );
  //   },
  // });

  useEffect(() => {
    if (dataInvoice) {
      setValue("customer_name", dataInvoice.customer_name);
      setValue("payment_method_id", dataInvoice.payment_method_id);
      setValue(
        "payment_due_date",
        FromStringToDate(dataInvoice.payment_due_date) || ""
      );
      setValue("customer_address", dataInvoice.customer_address || "");
      setValue(
        "customer_phone_number",
        dataInvoice.customer_phone_number || ""
      );
      setValue("description", dataInvoice.description);
      setValue("sub_dealer_id", dataInvoice.sub_dealer_id);
      setProductWithPriceData(
        dataInvoice.invoice_detail.map((item) => {
          return {
            id: item.id,
            name: `${item.product.product_category.category_name} -
          ${item.product.product_brand.brand_name} - ${item.product.product_type_name}`,
            price: item.price,
            quantity: item.quantity,
            unitType: item.product.unit_type,
            returQuantity: 0,
          };
        })
      );
    }
  }, [dataInvoice]);

  useEffect(() => {
    if (dataInvoiceConstant) {
      setValue("invoice_status", dataInvoice.status);
      setValue("invoice_type", dataInvoice.invoice_type);
    }
  }, [dataInvoiceConstant]);

  const handleRetur = () => {
    // const currentDate = new Date().toISOString();
    // const productList: any[] = [];
    // productWithPriceData.forEach((item) => {
    //   productList.push({
    //     invoice_detail_id: item.id,
    //     quantity: item.returQuantity,
    //   });
    // });
    // mutateRetur({
    //   description: getValues("descriptionRetur"),
    //   invoice_id: dataInvoice.id.toString(),
    //   payment_method_id: getValues("payment_method_id"),
    //   return_invoice_date: FromStringToDate(currentDate, true),
    //   product_list: JSON.stringify(productList),
    // });
    mutateCancel({
      invoice_id: dataInvoice.id.toString(),
      // description: getValues("descriptionRetur"),
      description: "",
    });
  };

  const handleOpenPaymentConfimation = async () => {
    setShowModal(true);
    // const isValid = await trigger(["descriptionRetur"]);
    // if (isValid) {
    //   setShowModal(true);
    // }
  };

  return (
    <form>
      <MainContainerForm mb={2}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Input.Text
              disable
              showAsStatic
              label="Nomor Invoice"
              value={dataInvoice.invoice_number}
            />
          </Grid>
          {!hideRetur && (
            <Grid item xs={12} md={6}>
              <Button
                onClick={() => setIsReturMode((prev) => !prev)}
                variant="outlined"
                color="secondary"
              >
                {isReturMode ? "Cancel" : "Batalkan Nota"}
              </Button>
            </Grid>
          )}
          <Grid item xs={12}>
            <PrintInvoice data={dataInvoice} />
          </Grid>
          <Grid item xs={12} md={6}>
            <Input.Controller
              control={control}
              name="invoice_type"
              rules={{ required: "Kolom ini tidak boleh kosong" }}
              render={(field, fieldState) => (
                <Input.Select
                  showAsStatic
                  disable
                  isFetching={isFetching}
                  label="Tipe Invoice"
                  options={dataInvoiceType || []}
                  value={field.value}
                  onChange={(e) => field.onChange(e.value)}
                  error={fieldState.error?.message}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Input.Controller
              control={control}
              name="invoice_status"
              rules={{ required: "Kolom ini tidak boleh kosong" }}
              render={(field, fieldState) => (
                <Input.Select
                  showAsStatic
                  disable
                  isFetching={isFetching}
                  label="Status Invoice"
                  options={dataInvoiceStatus || []}
                  value={field.value}
                  onChange={(e) => field.onChange(e.value)}
                  error={fieldState.error?.message}
                />
              )}
            />
          </Grid>
          <PaymentMethodInput
            disable
            control={control}
            isPaymentForm={true}
            dataInvoiceConstant={dataInvoiceConstant}
            invoice_status={watch("invoice_status")}
          />
          <Condition.IF
            condition={
              watch("invoice_status") !== undefined &&
              watch("invoice_status") ===
                dataInvoiceConstant?.status["Belum Lunas"]
            }
          >
            <Grid item xs={12} md={6}>
              <Input.Controller
                control={control}
                name="payment_due_date"
                render={(field) => (
                  <Input.Date
                    showAsStatic
                    disable
                    isFetching={isFetching}
                    label="Tanggal Jatuh Tempo"
                    value={field.value}
                    onChange={(e) => field.onChange(e)}
                  />
                )}
              />
            </Grid>
          </Condition.IF>
          <Condition.IF
            condition={
              watch("invoice_type") !== undefined &&
              watch("invoice_type") === dataInvoiceConstant?.type.Grosir
            }
          >
            <GrosirInput disable control={control} />
          </Condition.IF>
          <Condition.IF
            condition={
              watch("invoice_type") !== undefined &&
              watch("invoice_type") === dataInvoiceConstant?.type.Retail
            }
          >
            <RetailInput disable control={control} isFetching={isFetching} />
          </Condition.IF>
          <Grid item xs={12}>
            <Input.Controller
              control={control}
              name="description"
              rules={{ required: "Kolom ini tidak boleh kosong" }}
              render={(field, fieldState) => (
                <Input.TextArea
                  showAsStatic
                  isFetching={isFetching}
                  label="Catatan"
                  value={field.value}
                  onChange={(e) => field.onChange(e)}
                  error={fieldState.error?.message}
                />
              )}
            />
          </Grid>
          {/* {isReturMode && (
            <Grid item xs={12}>
              <Input.Controller
                control={control}
                name="descriptionRetur"
                rules={{ required: "Kolom ini tidak boleh kosong" }}
                render={(field, fieldState) => (
                  <Input.TextArea
                    isFetching={isFetching}
                    label="Catatan Retur"
                    value={field.value}
                    onChange={(e) => field.onChange(e)}
                    error={fieldState.error?.message}
                  />
                )}
              />
            </Grid>
          )} */}
        </Grid>
      </MainContainerForm>
      {dataInvoice.return_invoice && dataInvoice.return_invoice.length > 0 && (
        <MainContainerForm mb={2}>
          <TableFC
            showIndex
            body={bodyListRetur}
            head={headerListRetur}
            data={dataInvoice.return_invoice}
          />
        </MainContainerForm>
      )}
      <MainContainerForm>
        <ProductWithPriceInvoice
          body={bodyNonEdit}
          header={headerNonEdit}
          lastRowRender={lastRowNonEdit}
          invoiceType={watch("invoice_type")}
          dataProduct={productWithPriceData}
          onChange={(e) => setValue("product_list", e)}
        />
        {isReturMode && (
          <Box display={"flex"} justifyContent={"flex-end"} mt={2}>
            <LoadingButton
              onClick={() => handleOpenPaymentConfimation()}
              text="Retur"
              isLoading={false}
            />
          </Box>
        )}
      </MainContainerForm>
      <ModalFC open={showModal} onClose={() => setShowModal(false)}>
        <Box minHeight={150}>
          <Typography variant="h6" mb={1}>
            Apakah anda yakin ?
          </Typography>
          <Box display={"flex"} justifyContent={"flex-end"} mt={2} gap={2}>
            <Button variant="outlined" onClick={() => setShowModal(false)}>
              Cancel
            </Button>
            <LoadingButton
              onClick={() => handleRetur()}
              isLoading={loadingCancel}
              text={"Konfirmasi"}
            />
          </Box>
        </Box>
      </ModalFC>
    </form>
  );
}
